export { default as CogEmptyIcon } from './CogEmptyIcon';
